import React from 'react';
import { Transition } from '@headlessui/react';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useStaticQuery, graphql } from 'gatsby';
import {
  AiOutlineYoutube as YoutubeIcon,
  AiOutlineInstagram as InstagramIcon,
} from 'react-icons/ai';
import {
  FiFacebook as FacebookIcon,
  FiHeart as HeartIcon,
  FiMail as EnvelopeIcon,
} from 'react-icons/fi';
import { Search as DocSearch } from './DocSearch';
import { CgSearch } from 'react-icons/cg';
import { Search } from '../components/Search';
const searchIndices = [{ name: `Pages`, title: `Pages` }];

const Facebook = ({ url }: { url: string }) => (
  <a href={url} target="_blank" rel="noreferrer">
    <FacebookIcon className=" ml-4 h-6 w-6 text-white" />
  </a>
);

const Instagram = ({ url }: { url: string }) => (
  <a href={url} target="_blank" rel="noreferrer">
    <InstagramIcon className=" ml-4 h-7 w-7 text-white" />
  </a>
);

const Youtube = ({ url }: { url: string }) => (
  <a href={url} target="_blank" rel="noreferrer">
    <YoutubeIcon className=" ml-4 h-7 w-7 text-white" />
  </a>
);

const Heart = ({ url }: { url: string }) => (
  <a href={url} target="_blank" rel="noreferrer">
    <HeartIcon className=" ml-4 h-7 w-7 text-white" />
  </a>
);

const Footer = () => {
  const [showCopyHint, setShowCopyHint] = React.useState(false);
  const data = useStaticQuery(graphql`
    query {
      contentfulSite {
        socialLinks
        contactEmail
      }
    }
  `);

  const showHint = () => {
    setShowCopyHint(true);
    setTimeout(() => {
      setShowCopyHint(false);
    }, 5000);
  };

  return (
    <div className="mb-4">
      <Search indices={searchIndices} />
      <div className=" flex w-full  items-center justify-center pb-4 text-white opacity-50 md:justify-end">
        {/* <DocSearch
          appId={process.env.GATSBY_ALGOLIA_APP_ID}
          indexName="Pages"
          apiKey={process.env.GATSBY_ALGOLIA_SEARCH_KEY}
          render={(onOpen) => (
            <CgSearch
              className="ml-4 h-6 w-6 cursor-pointer text-white"
              onClick={onOpen}
            />
          )}
        /> */}
        {!!data.contentfulSite.contactEmail && (
          <>
            <Transition
              className="absolute translate-y-8 text-center text-xs "
              show={showCopyHint}
              enter="transition-opacity duration-10"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-1000"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              {`Copied ${data.contentfulSite.contactEmail}`}
            </Transition>
            <CopyToClipboard
              text={data.contentfulSite.contactEmail}
              onCopy={showHint}
            >
              <EnvelopeIcon className="ml-4 h-5 w-5 cursor-pointer" />
            </CopyToClipboard>
          </>
        )}
        {data.contentfulSite.socialLinks.map((s) => {
          const supported_socials = ['facebook', 'instagram', 'youtube'];
          const name = s
            .split('.')
            .find((comp) => supported_socials.includes(comp.toLowerCase()));

          switch (name) {
            case 'facebook':
              return <Facebook key={s} url={s} />;
            case 'instagram':
              return <Instagram key={s} url={s} />;
            case 'youtube':
              return <Youtube key={s} url={s} />;
            case 'heart':
              return <Heart key={s} url={s} />;
          }
        })}
      </div>
    </div>
  );
};

export default Footer;
